import React from 'react'

import { ContentSection } from 'src/common/components/ContentSection/ContentSection'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'

import { NumberBlock, NumberBlockProps } from './NumberBlock/NumberBlock'

import s from './AboutNumbersBlock.module.scss'

const BLOCKS: Array<NumberBlockProps> = [
  {
    titleNumber: 114,
    titlePostfix: 'K+',
    description: 'Talented Startup developers across 4 continents',
  },
  {
    titleNumber: 125,
    titlePostfix: '+',
    description: 'Skills and technologies covered by our vetting process',
  },
  {
    titleNumber: 89,
    titlePostfix: '%',
    description: 'Insquad interview-to-hire ratio',
  },
  {
    titleNumber: 300,
    titlePostfix: '+',
    description: 'Startups trust Insquad',
  },
]

export type AboutNumbersBlockProps = {}

export const AboutNumbersBlock: React.FC<AboutNumbersBlockProps> = () => {
  return (
    <ContentSection className="container">
      <Typography
        variant={EnumTypographyVariants.H2}
        text="Insquad by the numbers"
        className={s.AboutNumbersBlock__title}
      />

      <div className={s.AboutNumbersBlock__blocks}>
        {BLOCKS.map((block, i) => (
          <NumberBlock
            key={i}
            className={s.AboutNumbersBlock__block}
            {...block}
          />
        ))}
      </div>
    </ContentSection>
  )
}
